module.exports = __webpack_public_path__ + "img/play_store.4bfce97a.svg";